import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinService {

  private spinnerSubject = new Subject<boolean>();

  constructor() {
  }

  public get spinnerStates(): Observable<boolean> {
    return this.spinnerSubject.asObservable();
  }

  public spin(): void {
    this.spinnerSubject.next(true);
  }
  public stop(): void {
    this.spinnerSubject.next(false);
  }
}
